package anjuros.development.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import anjuros.development.components.PhotoCard
import anjuros.development.components.SectionTitle
import anjuros.development.modules.Nearby
import anjuros.development.modules.Section
import anjuros.development.modules.Theme
import anjuros.development.util.Constants.SECTION_WIDTH
import anjuros.development.util.ObserverViewportEntered
import anjuros.development.util.SmallSectionWidthStyle
import anjuros.development.util.rememberOrientation
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px

@Composable
fun NearbySection(){
    Box(
        modifier = Modifier
            .id(Section.Nearby.id)
            .backgroundColor(Theme.Primary.rgb)
            .maxWidth(SECTION_WIDTH.px),
        contentAlignment = Alignment.Center
    ) {
        Column (modifier = Modifier.fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally){
            NearbyContent()
        }
    }
}

@Composable
fun NearbyContent(){
    var animatedOpacity = remember { mutableStateOf(0.0f) }
    val isLandscape  by  rememberOrientation()

    ObserverViewportEntered(
        sectionId = Section.Nearby.id,
        distanceFromTop = 300.0
    ) {
        animatedOpacity.value = 1.0f
    }

    Column(
        modifier = Modifier.fillMaxWidth()
        ,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SectionTitle(
            modifier = SmallSectionWidthStyle.toModifier()
                .margin(topBottom = 50.px),
            section = Section.Nearby,
            lightMode = true,
            alignment = Alignment.CenterHorizontally
        )
        SimpleGrid(numColumns = numColumns(base = if(isLandscape) 2 else 1, md = 2, lg = 3)) {
            Nearby.entries.forEach { nearby ->

                PhotoCard(nearby = nearby,
                    animatedOpacity = animatedOpacity.value)
            }
        }

    }
}